import { render, staticRenderFns } from "./ViewVendorLocation.vue?vue&type=template&id=36f4885e"
import script from "./ViewVendorLocation.vue?vue&type=script&lang=ts"
export * from "./ViewVendorLocation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports